module.exports = __webpack_public_path__ + "img/piece-locked-8.d0f50f1e.svg";